module.exports = __webpack_public_path__ + "img/print.0c44f353.svg";